module.exports = __webpack_public_path__ + "static/media/gazeta92_mobile.c12c24d8.jpg";